// Language Switcher Dropdown
const languageSwitcher = document.querySelector('.language-switcher');

if (languageSwitcher) {
    const toggle = languageSwitcher.querySelector('.language-switcher__toggle');
    const dropdown = languageSwitcher.querySelector('.language-switcher__dropdown');

    if (toggle && dropdown) {
        toggle.addEventListener('click', (e) => {
            e.stopPropagation();
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
                toggle.setAttribute('aria-expanded', 'false');
                languageSwitcher.classList.remove('active');
            } else {
                toggle.setAttribute('aria-expanded', 'true');
                languageSwitcher.classList.add('active');
            }
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
            if (!languageSwitcher.contains(e.target)) {
                toggle.setAttribute('aria-expanded', 'false');
                languageSwitcher.classList.remove('active');
            }
        });

        // Close dropdown on escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && languageSwitcher.classList.contains('active')) {
                toggle.setAttribute('aria-expanded', 'false');
                languageSwitcher.classList.remove('active');
                toggle.focus();
            }
        });
    }
}